import request from './request'
type RequestParams = Record<string, any>

const sendPost = (
    url: string,
    param: RequestParams,
    headers?: RequestParams,
): Promise<any> => {
    headers = headers ? headers : {}
    return request({
        url,
        method: 'post',
        headers: {
            ...headers,
        },
        data: param,
    })
}

const api = {
    alias:{
        queryList:(param:RequestParams)=>{
            return  sendPost('/api/PbmServer/globalLabelConfig/page',param,{loading:'false'})
        },
        update:(param:RequestParams)=>{
            return sendPost('/api/PbmServer/globalLabelConfig/save',param,{loading:'false'})
        },
        delete:(param:RequestParams)=>{
            return sendPost('/api/PbmServer/globalLabelConfig/delete',param,{loading:'false'})
        },
        queryUserConfig:(param:RequestParams)=>{
            return sendPost('/api/PbmServer/globalLabelConfig/getUserGlobalLabelConfig',param,{loading:'false'})
        },
        initSCMRelationList: (param:RequestParams)=>{
            return sendPost('/api/PbmServer/globalLabel/switch',param,{loading:'false'})
        },
    },
    careLabel:{
        queryList:(param:RequestParams)=>{
            return  sendPost('/api/sgs-pbm/component/carelabelQuickTag/page',param,{loading:'false'})
        },
        deleteList:(param:RequestParams)=>{
            return  sendPost('/api/sgs-pbm/component/carelabelQuickTag/delete',param,{loading:'false'})
        },
        save:(param:RequestParams)=>{
            return  sendPost('/api/sgs-pbm/component/carelabelQuickTag/save',param,{loading:'false'})
        },
        list:(param:RequestParams)=>{
            return  sendPost('/api/sgs-pbm/component/carelabelQuickTag/list',param,{loading:'false'})
        },
    }

}

export default api;